(() => {
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  $$('[data-il-hotspot]').forEach((hotspot) => {
    hotspot.addEventListener('click', (event) => {
      if (window.matchMedia('(max-width: 768px)').matches) {
        const open = hotspot.classList.contains('is-open');
        $$('[data-il-hotspot].is-open').forEach((el) => el.classList.remove('is-open'));
        if (!open) {
          event.preventDefault();
          hotspot.classList.add('is-open');
        }
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-il-hotspot]')) return;
    $$('[data-il-hotspot].is-open').forEach((el) => el.classList.remove('is-open'));
  });

  $$('[data-il-products-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-il-carousel-track]');
    const nav = carousel.querySelector('[data-il-carousel-nav]');
    const prev = nav?.querySelector('[data-il-carousel-prev]');
    const next = nav?.querySelector('[data-il-carousel-next]');
    if (!track || !prev || !next) return;

    const scrollStep = () => {
      const card = track.querySelector('.product-card');
      if (!card) return track.clientWidth * 0.75;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.offsetWidth + gap;
    };

    const updateNav = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 4) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= maxScroll - 4;
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: scrollStep() * dir, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByStep(-1));
    next.addEventListener('click', () => scrollByStep(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();
